import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store';

export default function ProtectedRoute() {
  const location = useLocation();
  const token = useAuthStore((state) => state.token);
  const user = useAuthStore((state) => state.user);
  const hydrated = useAuthStore((state) => state.hydrated);
  const requestedPortal = location.pathname.startsWith('/superadmin')
    ? 'superadmin'
    : location.pathname.startsWith('/admin')
      ? 'admin'
      : 'staff';

  if (!hydrated) {
    return (
      <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center">
        <div className="text-sm text-gray-500">Chargement...</div>
      </div>
    );
  }

  if (!token || !user) {
    return <Navigate to={`/${requestedPortal}/login`} replace state={{ from: location }} />;
  }

  return <Outlet />;
}
